import type { SharePointItemsViewNavigationLocationState } from '../Schema/SharePointItemsViewNavigationLocationState';
import { createStore } from 'owa-satcheljs';
const initialState = new Map<string, SharePointItemsViewNavigationLocationState>();

export const getStore: () => Map<string, SharePointItemsViewNavigationLocationState> = createStore(
    'SharePointItemsViewNavigationLocationStore',
    initialState
);
